import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Col,
  Modal,
  Row,
  Input,
  Typography,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { patchVehiculo } from 'api/recaudacion/vehiculos';
import { onError } from 'utils/handlers';

import { patchMotocicleta } from 'api/recaudacion/motocicletas';
import { patchRemolque } from 'api/recaudacion/remolque';
import { noSymbolsCapitalized } from 'utils/normalizers';

const patchVehiculosMap = {
  4: patchVehiculo,
  16: patchMotocicleta,
  17: patchRemolque,
};

const WidgetRfcEmisor = ({
  visible,
  setVisible,
  message,
  vehiculoId,
  callback,
  tipoDePadronVehicular,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };
  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const saved = await patchVehiculosMap[tipoDePadronVehicular](vehiculoId, values);
      if (saved) {
        callback(saved);
        onCancel();
      }
      setLoading(false);
    } catch (error) {
      onError(error);
    }
  };
  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      title={(
        <FormSubmitControls
          label="Agregar Información Restante"
          onFinish={onFinish}
          onCancel={onCancel}
          loading={loading}
        />
      )}
      keyboard={!loading}
      maskClosable={!loading}
      onCancel={onCancel}
      forceRender
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  name="rfc_emisor_cfdi"
                  label="RFC Emisor CFDI"
                  rules={[{ required: true }]}
                  normalize={noSymbolsCapitalized}
                >
                  <Input
                    disabled={loading}
                    allowClear
                    maxLength={11}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Typography.Text>
                  {message}
                </Typography.Text>
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>
      </Spin>
    </Modal>
  );
};

WidgetRfcEmisor.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  vehiculoId: PropTypes.number,
  tipoDePadronVehicular: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
  message: PropTypes.string,

};

WidgetRfcEmisor.defaultProps = {
  vehiculoId: null,
  message: null,

};

export default WidgetRfcEmisor;
